// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.encuesta-container {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 100px);
  padding-bottom: 100px;
  position: relative;
}

.encuesta-body{
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  width: 100%;
  margin-top: 20px;
}

.typeform-embed {
  width: 100%;
  height: 700px;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  margin-top: 20px;
  margin-bottom: 50px;
}

.typeform-embed iframe {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  position: absolute;
  top: 0;
  left: 0;
}

.gracias-message {
  text-align: center;
  font-size: 1.5em;
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Evaluations/TypeFormPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".encuesta-container {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: calc(100vh - 100px);\n  padding-bottom: 100px;\n  position: relative;\n}\n\n.encuesta-body{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 800px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.typeform-embed {\n  width: 100%;\n  height: 700px;\n  max-width: 800px;\n  margin: 0 auto;\n  position: relative;\n  margin-top: 20px;\n  margin-bottom: 50px;\n}\n\n.typeform-embed iframe {\n  width: 100% !important;\n  height: 100% !important;\n  border: none !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.gracias-message {\n  text-align: center;\n  font-size: 1.5em;\n  margin-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
